import { jsx as e } from "react/jsx-runtime";
import { Card as c, FlexBox as m } from "@vp/swan";
/* empty css                    */
const p = (r) => {
  const { cardOverrides: n, containerOverrides: a, children: i, isMinimal: s = !0 } = r, { className: t, ...l } = n || {};
  return /* @__PURE__ */ e(
    c,
    {
      textAlign: "left",
      className: `channel-card ${s ? "minimal-channel-card" : ""} ${t || ""}`,
      p: "4",
      bordered: !0,
      ...l,
      children: /* @__PURE__ */ e(m, { flexDirection: "column", justifyContent: "space-between", style: { height: "100%" }, ...a, children: i })
    }
  );
};
export {
  p as ChannelCard
};
//# sourceMappingURL=contact-channels75.js.map
